<template>
	<div id="liveView">
		<RTStreamProgram/>
  </div>
</template>

<script>
import RTStreamProgram from '@/components/RTStreamProgram.vue'
  export default {
	name: 'LiveView',
	mixins:[],
    components: {
		RTStreamProgram
	},
	methods:{
	},
  }
</script>

<style scoped>

</style>
